import { ExtractPropTypes } from 'vue'

export const breadcrumbItemProps = {
	/**
	 * 路由跳转对象，同 vue-router 的 to
	 */
	to: {
		type: [String, Object],
		default: '',
	},
	/**
	 * 是否使用 replace 模式进行路由跳转
	 */
	replace: {
		type: Boolean,
		default: false,
	},
}

export type BreadcrumbItemProps = ExtractPropTypes<typeof breadcrumbItemProps>
